import { Container, Button } from '@mui/material';

import Iframe from 'react-iframe';
import Header from './Header';
import Footer from './Footer';
import GetUrlPath from '../shared/utilities/getUrlPath';
import Downloads from '@mui/icons-material/Refresh';
import { useState } from 'react';
import GetResultUrl from '../shared/utilities/getResultUrl';

function Resultlists() {

    //var route_path = "splashdata/" + GetUrlPath()
    var local_url = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port
    var base_url = process.env.REACT_APP_SPLASH_URL === undefined ? local_url : process.env.REACT_APP_SPLASH_URL
    var result_url = GetResultUrl(base_url, GetUrlPath())

    console.log(result_url)

    const [random, setRandom] = useState(0);

    function resetIframe() {
        setRandom(random + 1);
        window.location.reload();
    }

    function getAllPages() {
        return <>
            <Header numberPage={1} detail={GetUrlPath()} />
            <Container
                maxWidth="lg"
                disableGutters
                sx={{ border: 'none', boxShadow: 'none', background: 'transparent' }} // Keine Randlinie, kein Schatten
            >
                <div style={{ display: 'flex', justifyContent: 'right', marginBottom: 0.5 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={resetIframe}
                        sx={{ backgroundColor: 'grey.500', '&:hover': { backgroundColor: 'grey.700' } }}
                    >
                        <Downloads />
                    </Button>
                </div>
                <Iframe
                    url={result_url}
                    height="1000"
                    width="100%"
                    id="myId"
                    display="inline"
                    key={random.toString()}
                />
            </Container>
            <Footer />
        </>
    }

    return (
        getAllPages()
    );

}

export default Resultlists


